import React, { useState } from "react";
import "./home.scss";
import Navbar from "../../compunets/navbar/Navbar";
import Button from "../../compunets/button/Button";
import rent from "../../images/rent.svg";
import furnish from "../../images/Furnish.svg";
import artisan from "../../images/artisan.svg";
import recvect from "../../images/recvector.png";
import boxgrid from "../../images/Group 50.png";
import connect from "../../images/connect.svg";
import avatar from "../../images/Avartar.png";
import handshake from "../../images/handshake.gif";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import { useAnimation } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import {  } from '@fortawesome/free-brands-svg-icons'
import {
  faRecycle,
  faMoneyBill,
  faWallet,
  faHouseCircleCheck,
  faSquareArrowUpRight,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { ProfileData } from "../../compunets/ProfileData";

function Home() {

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email : ""
  })

  function handleChange(event) {
    const {name, value, type, checked} = event.target 
    setFormData(pervFormData => ({
      ...pervFormData,
      [name] : value
    }))
  }


  
  

  function emailValidation (event) {
    
  }

  function handleSubmit(event) {
    // alert('Welcome: ' + formData.email);
    event.preventDefault()
    let errorMesg = ['Enter valid email address'];
    const errorElemet = document.getElementById('emailAlert');
    if (!formData.email) {
      errorElemet.innerText = errorMesg
      return ;
    }
    // fetch('', {
        //   method: 'POST',
        //   headers: {"content-type": "email"},
        //   body: JSON.stringify(formData.email)
        // })
        navigate('/thanks') ;

  }


  return (
    <div className="home">
      <Navbar />
      <section className="hero">
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ type: "spring", duration: 1.5, bounce: 0.3 }}
          className="leftCol"
        >
          <h1>
            An Ecosystem of Residential Services Powered by Artificial
            Intelligence.
          </h1>
        <p>
          Looking for a platform that provides solutions to all<br/> your housing needs for a deserving soft life?<br/> <strong>Download IVA</strong>
        </p>

          <p
          id="emailAlert"
          style={{ fontSize: "13px", color: "rgb(244, 38, 38)" }}
        ></p>
          <form onSubmit={handleSubmit} className="form">
  

          <input
            type="email"
            name="email"
            id="email"
            placeholder="email address"
            onChange={handleChange}
            value={formData.email}
          />
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }} 
            type="submit">
              Get early access
              </motion.button>
        </form>




        
        </motion.div>
        <div className="rightCol">
          <motion.img
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.9 }}
            src={avatar}
            alt="iva avartar"
          />
        </div>
      </section>

      <section className="about" id="about">
        <h1>
          <span>Iva Africa </span>is a startup improving the living experience
          of young Africans.
        </h1>
        <p>
          Our mobile app is built to provide you a smooth living experience
          tailored to your lifestyle and income. With multiple proptech startups
          not being able to solve housing issues among young people, the team
          behind Iva Africa is working hard to bring you the only housing app
          you will ever need.
        </p>
      </section>
      <section className="services" id="services">
        <div className="rent">
          <div className="imgCont">
            <motion.img
              initial={{ scale: 0.5, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", duration: 1, bounce: 0.3 }}
              viewport={{ once: true }}
              className="serImg"
              src={rent}
              alt=""
            />
            
          </div>
          <div className="decs">
            <h2>Rent an Apartment</h2>
            <p>
              360 degree virtual tour. No hidden charges, no agreement fee, no
              commission fee. No extra payment. Monthly payment also available.
              Pay your rent and pack.
            </p>
          </div>
        </div>

        <div className="furnish">
          <div className="imgCont">
            <motion.img
              className="serImg"
              initial={{ scale: 0.5, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", duration: 1, bounce: 0.3 }}
              viewport={{ once: true }}
              src={furnish}
              alt=""
            />
            
          </div>
          <div className="decs">
            <h2>Furnish your Apartment</h2>
            <p>
              Use our virtual staging technology to try out furniture in your
              apartment before paying. Get the cheapest and quality furniture
              from carefully selected vendors. Enjoy varieties of payment
              options.
            </p>
          </div>
        </div>

        <div className="repair">
          <div className="imgCont">
            <motion.img
              className="serImg"
              initial={{ scale: 0.5, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", duration: 1, bounce: 0.3 }}
              viewport={{ once: true }}
              src={artisan}
              alt=""
            />
            {/* <div className="box"></div> */}
          </div>
          <div className="decs">
            <h2>Get the Right Artisan</h2>
            <p>
              Get Skilled and verified artisans closest to your location. Enjoy
              your money worth of quality service and timely delivery. Choose
              from many options anytime in the day. Enjoy flexible payment. Rate
              and drop your review.
            </p>
          </div>
        </div>

        <div className="connect">
          <div className="imgCont">
            <motion.img
              className="serImg"
              initial={{ scale: 0.5, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", duration: 1, bounce: 0.3 }}
              viewport={{ once: true }}
              src={connect}
              alt=""
            />
            
          </div>
          <div className="decs">
            <h2>Connect to Neighbors</h2>
            <p>
              Find the right flat mate with our intelligent pairing technology.
              Iva also connects you to people living around you based on your
              preference so you do not have to feel alone anymore.
            </p>
          </div>
        </div>

        
      </section>

      <div className="finance">
          <div className="walletCont">
            <h2>We've Got Your Housing Finance Covered</h2>
            <div className="walletItems">
              <div className="wallet fin">
                {/* <AccountBalanceWalletOutlinedIcon className="avatar" /> */}
                <FontAwesomeIcon icon={faWallet} className="avatar green" />

                <p>
                  Wallet for save for house expenses; earn interest in your
                  savings
                </p>
              </div>

              <div className="payRent fin">
                {/* <CottageOutlinedIcon className="avatar" /> */}
                <FontAwesomeIcon icon={faHouseCircleCheck} className="avatar orange" />
                <p>
                  Rent now, Pay later; rent an apartment with zero naira and
                  pay later.
                </p>
              </div>

              <div className="waste fin">
                {/* <DeleteSweepOutlinedIcon className="avatar" /> */}
                <FontAwesomeIcon icon={faRecycle} className="avatar blue" />
                <p>Waste for Cash; exchange your plastic waste for money</p>
              </div>

              <div className="loan fin">
                {/* <MonetizationOnOutlinedIcon className="avatar" /> */}
                <FontAwesomeIcon icon={faMoneyBill} className="avatar purple" />
                <p>
                  Get a rent loan from us at the cheapest rate and pay your
                  landlord directly.
                </p>
              </div>
            </div>
          </div>
        </div>

      <section className="team" id="team">
        <h2>Meet the Team</h2>

        <div className="teamProfile">
          {ProfileData.map((item, index) => {
            return (
              <div key={index} className="profile">
                <img src={item.Image} alt="" />
                <div className="profileInfo">
                  <p className="name">
                    {item.fname} {item.lName}
                  </p>
                  <p className="role">{item.position}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="contact" id="contact">
        <div className="leftCol">
          <div className="abus">
            <ul className="abusList">
              <li className="abusItem">
                <h3>About Us</h3>
              </li>
              <li className="abusItem">
                <Link to="" style={{ textDecoration: "none", color: "#000" }}>
                  Our Vision
                </Link>
              </li>
              <li className="abusItem">
                <Link to="" style={{ textDecoration: "none", color: "#000" }}>
                  Contact Us
                </Link>
              </li>
              <li className="abusItem">
                <Link to="" style={{ textDecoration: "none", color: "#000" }}>
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          <div className="resources">
            <ul className="abusList">
              <li className="abusItem">
                <h3>Resources</h3>
              </li>
              <li className="abusItem">
                <Link to="" style={{ textDecoration: "none", color: "#000" }}>
                  Terms of Services
                </Link>
              </li>
              <li className="abusItem">
                <Link to="" style={{ textDecoration: "none", color: "#000" }}>
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="rightCol">
          <h2>Get in touch!</h2>
          <div className="contactInfo">
            <div className="phoneNum">
              {" "}
              <FontAwesomeIcon icon={faPhone} className="avatar" />
              <p>+234 (80)-575-15009</p>
            </div>
            <div className="address">
              <address>
                <FontAwesomeIcon icon={faLocationDot} className="avatar" />
                44,Commercial Avenue, Sabo, Yaba
              </address>
            </div>
            <div className="socialInfo">
              <a href="#" className="logo">
                <FacebookIcon className="avatar" />
              </a>

              <a href="https://www.instagram.com/iva_africa_/" className="logo">
                <InstagramIcon className="avatar"/>
              </a>

              <a href="https://twitter.com/AppIvatech" className="logo">
                <TwitterIcon className="avatar"/>
              </a>

              <a href="https://www.linkedin.com/in/iva-africa-616327241/" className="logo">
                <LinkedInIcon className="avatar"/>
              </a>

              <a href="mailto:Ivatech.app@gmail.com"  className="logo">
                <EmailOutlinedIcon className="avatar"/>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="footer">
        <p>©2022 IVA Africa. All rights reserved.</p>
      </section>
    </div>
  );
}

export default Home;
